import type { BulkPromoStatus, JobDetails } from '@/types';

const statusOrder = {
    complete: 1,
    'complete-with-errors': 2,
    processing: 3,
    pending: 4,
    failed: 5,
};

export function sortByStatus(data: JobDetails[]) {
    data.sort(
        (a, b) =>
            statusOrder[a.status.toLowerCase() as BulkPromoStatus] -
            statusOrder[b.status.toLowerCase() as BulkPromoStatus]
    );

    return data;
}
